import React from 'react';

const Dropshipping = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.8072 7.85869C24.2285 8.04594 24.5 8.46375 24.5 8.9248V19.1468C24.5 19.5705 24.2703 19.9609 23.8999 20.1667L14.5666 25.3518C14.2142 25.5476 13.7858 25.5476 13.4334 25.3518L4.10008 20.1667C3.72971 19.9609 3.5 19.5705 3.5 19.1468V8.9248C3.5 8.46375 3.77152 8.04594 4.19284 7.85869L13.5262 3.71054C13.8278 3.57647 14.1722 3.57647 14.4738 3.71054L23.8072 7.85869Z"
      fill="#3448FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4617 4.92847L8.8667 9.70347V15.0566L11.2 16.2233V11.0764L20.1309 6.11479L17.4617 4.92847Z"
      fill="#FFC85F"
    />
  </svg>
);

export default Dropshipping;
